/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

export const ContactTypeIDs = {
    artisan: "0011",
    chocolatier: "0014",
    industry: "0021",
    supermarket: "0022",
    retail: "0023",
    job: "JobAp",
    supplier: "SupAg",
    other: "0075",
};

export const ContactReasonIDs = {
    productInfo: "1",
    sales: "2",
    support: "3",
    other: "4",
}

export const ContactCustomerOptions = [
    {id: "false", value: "I'm not a Puratos customer"},
    {id: "true", value: "I'm an existing customer"},
];

export interface ContactFormComponent {
    formFields: {
        optinLabel: string,
        privacyPolicyLabel: string,
        sendButtonText: string,
        numberOptional: boolean,
        boxMandatory: boolean,
        boxOptional: boolean,
        stateMandatory: boolean,
        otherMandatory: boolean,
        subjectMandatory: boolean,
        customerSelectMandatory: boolean,
        customerNumberOptional: boolean,
        enableMapsAPI: boolean,
        hideStreet: boolean,
        hideNumber: boolean,
        hideZip: boolean,
        hideCity: boolean,
    },
    formMessages: {
        customerNumberMsg: string,
        fieldErrorMsg: string,
        firstNameMsg: string,
        lastNameMsg: string,
        companyNameMsg: string,
        companyVatMsg: string,
        emailMsg: string,
        addressMsg: string,
        phoneMsg: string,
        productMsg: string,
        messageMsg: string,
    },
    formSuccessMessage: string,
    formErrorMessage: string,
    formIncompleteMessage: string,
    availableCountryList: [
        {
            title: string,
            value: string,
            isocode: string,
        }
    ],
    recaptchaSiteKey: string,
    mapsAPIKey: string,
    contactProfiles: [{id: string, value: string}],
    contactReasons: [{id: string, value: string}],
    formCountry: string
}
